import api from "../../config/api";

const state = {
  monthToDateUsage: null,
};

const mutations = {
  setMonthToDateUsage(state, payload) {
    state.monthToDateUsage = payload;
  },
};

const actions = {
  async fetchMonthToDateUsage({ commit }, payload = {}) {
    try {
      const response = await api.post(`/managelocationajax`, {
        cmd: "getmonthtodateusage",
        ...payload,
      });
      const result = response?.data?.output ?? response?.data ?? null;
      commit("setMonthToDateUsage", result);
      return result;
    } catch (error) {
      console.error("Error fetching month-to-date usage:", error);
      throw error;
    }
  },
};

const getters = {
  stMonthToDateUsage: (state) => state.monthToDateUsage,
};

export default {
  state,
  mutations,
  actions,
  getters,
};

